import IFinancingParameter from "@/module/main/dto/IFinancingParameter";
import IInstallmentScheduleParameter from "@/module/main/dto/IInstallmentScheduleParameter";

export default class InstallmentScheduleParameter implements IInstallmentScheduleParameter
{
    constructor(
        public numberOfInstallment: number,
        public financingParameters: IFinancingParameter[]
    )
    {
    }
}
